import { create } from 'zustand';

export type DeploymentDetails = {
  visible?: boolean;
  modalVisible?: boolean;
  id: string;
  deployment?: unknown;
};

type DeployUiState = {
  isDeploySheetOpen: boolean;
  pipelineToRedeploy: unknown | null;
  deploymentDetails: DeploymentDetails;
  setDeploySheetOpen: (open: boolean) => void;
  closeDeploySheet: () => void;
  startRedeploy: (pipeline: unknown) => void;
  showDeploymentDetails: (details: DeploymentDetails) => void;
  reset: () => void;
};

const initialState = {
  isDeploySheetOpen: false,
  pipelineToRedeploy: null,
  deploymentDetails: { modalVisible: false, id: '' }
};

export const useDeployUiStore = create<DeployUiState>(set => ({
  ...initialState,
  setDeploySheetOpen: open =>
    set({ isDeploySheetOpen: open, pipelineToRedeploy: null }),
  closeDeploySheet: () =>
    set({ isDeploySheetOpen: false, pipelineToRedeploy: null }),
  startRedeploy: pipeline =>
    set({ pipelineToRedeploy: pipeline, isDeploySheetOpen: true }),
  showDeploymentDetails: details => set({ deploymentDetails: details }),
  reset: () => set(initialState)
}));
